export const WIZARD_FOOTER_HEIGHT = 86;
